import React from 'react'; // Global States for faster scheduling

import { useStore } from "../../contexts/store";
import moment from 'moment';

const ExpertHeader = ({
  handleTimezones
}) => {
  const {
    state
  } = useStore();
  const {
    availabilityStore_imp,
    expertTimezoneName
  } = state;
  const filteredTzs = availabilityStore_imp.staticData.timezones.sort((a, b) => {
    const nameA = a.name.toLowerCase();
    const nameB = b.name.toLowerCase();
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "titleWrapper"
  }, /*#__PURE__*/React.createElement("p", {
    className: "tableTitleE"
  }, "Expert"), /*#__PURE__*/React.createElement("select", {
    id: "handleTimezonesExpert",
    onChange: handleTimezones,
    style: {
      height: '25px'
    },
    className: "selectTimezone",
    value: expertTimezoneName
  }, filteredTzs.map(x => /*#__PURE__*/React.createElement("option", {
    key: x.id,
    value: x.name
  }, window && window.outerWidth < 768 ? x.isoCode2 : x.name, ' ', moment().utc().tz(x.name).format('Z'))))));
};

export default ExpertHeader;